// extracted by mini-css-extract-plugin
export default {"chart":"NewCustomer_chart__Wjmqu","legend":"NewCustomer_legend__aCWlO","indicator":"NewCustomer_indicator__xNkRi","color":"NewCustomer_color__1r8sD"};